module.exports = __webpack_public_path__ + "static/media/HCMM966.bb00a501.jpg";